import { useState, useCallback, useEffect } from "react";
import { GetUserRequest, User } from "../proto/api_pb";
import { GetUserResponse } from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { RpcError } from "grpc-web";
import { backOff } from "exponential-backoff";

type ReturnType = {
  user: User | undefined;
  isUserLoading: boolean;
  getUserResponse: GetUserResponse | undefined;
  getUserError: RpcError | undefined;
};
export const useGetPublicUser = (username?: string): ReturnType => {
  const [user, setUser] = useState<User>();
  const [getUserResponse, setGetUserResponse] = useState<GetUserResponse>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<RpcError>();

  const getPublicUser = useCallback(async () => {
    try {
      if (username) {
        setIsLoading(true);
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetUserRequest();
        request.setUsername(username);
        const metadata = {
          "Access-Control-Allow-Origin": "*",
        };
        await backOff(
          () =>
            new Promise((resolve, reject) => {
              ommuseClient.getPublicUser(
                request,
                metadata,
                function (err, response) {
                  if (err) {
                    console.log(err.code);
                    console.log(err.message);
                    setIsLoading(false);
                    reject(err);
                  } else {
                    setUser(response);
                    setGetUserResponse(response);
                    setIsLoading(false);
                    resolve(response);
                  }
                }
              );
            }),
          {
            numOfAttempts: 3,
            jitter: "full",
          }
        );
      }
    } catch (error) {
      setError(error as RpcError);
    }
  }, [username]);

  useEffect(() => {
    getPublicUser();
  }, [getPublicUser]);

  return {
    user,
    isUserLoading: isLoading,
    getUserResponse,
    getUserError: error,
  };
};
